import { useSelector } from '@lingoda/hooks';
import { studentPreferencesSelector } from '@lingoda/students';

export const useSelectWasCalendarWidgetDismissed = () => {
    const preferences = useSelector(studentPreferencesSelector);

    return preferences?.dismissedWidgets?.calendarReminderWidget === true;
};
